import * as ReselectModule from "reselect";
import { IHealthInsuranceListState } from ".";
import { IApplicationState } from "..";

export const selectHealthInsuranceList: ReselectModule.Selector<
  IApplicationState,
  IHealthInsuranceListState
> = (state) => state.healthInsuranceList;
